import React          from 'react';
import EggBox         from '../../components/EggBox';
import { makeStyles } from '@material-ui/core/styles';

var clsx = require('classnames')

  

const useStyles = makeStyles(() => ({
    root: {
        position:   'fixed',
        transition: 'transform 0.4s'
    },
    left: {
       left:            0,
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'space-evenly'
    },
    right: {
       right:            0,
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'space-evenly'
    },
    small: {
    },
    unit: {
       cursor:          'pointer',
       display:         'flex',
       alignItems:      'center',
       justifyContent:  'center',
    },
  /*   shake: {
        animation:               'shake 0.5s',
        animationIterationCount: '0.5s',
    },
      dont_shake: {
    } */
    
}))

type GridProps = {
    size:               number[];
    correctValues:      number[];
    variant:            number;
    showClearButton:    boolean;
    showAnswer:      boolean;
    handleRejectEggBox: () => void;
    handleMouseDown:    (e: React.MouseEvent, ind: number) => void;
    handleTouchStart:   (e: React.TouchEvent, ind: number) => void;
}

const Grid: React.FC<GridProps> = ({ 
    size, 
    correctValues, 
    variant, 
    showClearButton,
    showAnswer,
    handleMouseDown, 
    handleTouchStart, 
    handleRejectEggBox 
 }) => {

 const classes = useStyles();

 /* const [shake, setShake] = React.useState(-1)

 const handleShake = (val: number) => {
    setShake(val)
    setTimeout(() => {
       setShake(-1)
    },500)
  } */

 const handleMouse = (e: React.MouseEvent, val: number) => {
     if (!correctValues.includes(val + 1)) {
        handleRejectEggBox()
    } 
  /*   else { */
        handleMouseDown(e, val)
   /*  } */
 }

 const handleTouch = (e: React.TouchEvent, val: number) => {
     if (!correctValues.includes(val + 1)) {
        handleRejectEggBox()
    }
  /*  else { */
        handleTouchStart(e, val)
   /*  } */
}


const [smallScreen, imgSize, rootStyle, unitStyle] = React.useMemo(() => {

    const SM = size[0] < 750;

    return [
        SM,
        ((size[0] > 950 && size[1] > 500 ) ? [150, 60] : SM ? [60, 30] : [90, 40]),
        {
           width:               SM ? '100vw' : size[0] < 1100 ? 150 : '17vw',
           top:                 SM ? size[1] - 130 : 150,
           height:              SM ? 130 : size[1] - 152,
           alignItems:          SM ? '' : 'center',
           flexFlow:            SM ? '' : 'column',
           display:             SM ? 'grid' : 'flex',
           gridTemplateColumns: SM ? 'repeat(5, 1fr)' : '',
           transform:           `translate(0px, ${ showAnswer || showClearButton ? 150 : 0 }vh)`
        },
        {
            width:     SM ? '100%' : size[0] < 1100 ? 90 : '100%',
            marginTop: SM ? 0 : 5,
        }
    ]
},[size, showClearButton, showAnswer])

  return (
        <div 
          className = { clsx(classes.root, (!smallScreen ? (variant === 0 ? classes.left : classes.right) : classes.small)) }
          style     = { rootStyle }
        >
            {
                new Array(smallScreen ? 10 : 5).fill(0).map((val, ind) => {

                    const myIndex = smallScreen ? ind : variant ? ind + 5 : ind;

                    return (
                        <div 
                           key          = { `exercises_solutions${ ind }${ variant }` }
                      //     className    = { clsx(classes.unit, (shake === myIndex ? classes.shake : classes.dont_shake)) }
                           className    = { classes.unit }
                           onMouseDown  = { e => { handleMouse(e, myIndex) }}
                           onTouchStart = { e => { handleTouch(e, myIndex) }}
                           style        = { unitStyle }
                        >
                           <EggBox
                              wideScreen = { false }
                              value      = { myIndex + 1 }
                              imgSize    = { imgSize }
                           />
                        </div>
                    )
                })
            }
        </div>
  );
}



export default Grid;








